import React, { Component } from "react";
import $ from "jquery";
import "./DynamicAsset.scss";

class DynamicAsset extends Component {
  constructor() {
    super();
  }
  render(index) {
    let img = this.props.image;
    return (
      <div className="dynamic-content-asset" id={this.props.image}>
        <div className="dynamic-content-asset-thumbnail"></div>
        <div className="dynamic-content-asset-content">
          <div className="dynamic-content-asset-label">{this.props.title}</div>
          <div className="dynamic-content-asset-text">
            {this.props.description}
          </div>
          <a
            className="btn dynamic-content-asset-btn"
            href={this.props.ctaURL}
            target="_blank"
          >
            {this.props.ctaText}
          </a>
        </div>
      </div>
    );
  }
}

export default DynamicAsset;
